<template>
	<system v-if="isOpen" class="system system--beacons">
		<ElementHeadlineBig content="Beacon Scanner" />

		<ElementButton name="close" type="close" @click="close" />
		<ElementSetting
			name="exhibitionsBeacons"
			content="Scan for Beacons:"
			type="checkbox"
			:value="bluetooth.isActive"
			:update="updateFunctionFactory(mutationTypes.bluetoothToggle, 'value')"
		/>
		<ElementHeadlineSmall content="Scan Config" />
		<ElementSetting
			name="timeout"
			content="Beacon Timeout:"
			type="number"
			inputmode="numeric"
			pattern="[0-9]*"
			:value="bluetooth.config.beaconTimeout"
			:update="updateFunctionFactory(mutationTypes.bluetoothSetScanConfig, 'beaconTimeout')"
		/>
		<ElementSetting
			name="scanInterval"
			content="Scan Intervall:"
			type="number"
			inputmode="numeric"
			pattern="[0-9]*"
			:value="bluetooth.config.scanInterval"
			:update="updateFunctionFactory(mutationTypes.bluetoothSetScanConfig, 'scanInterval')"
		/>
		<ElementSetting
			name="exhibitionsBeacons"
			content="Only Exhibtion Beacons:"
			type="checkbox"
			:value="bluetooth.config.onlyExhibitionBeacons"
			:update="updateFunctionFactory(mutationTypes.bluetoothSetScanConfig, 'onlyExhibitionBeacons')"
		/>
		<ElementSetting
			name="filter"
			content="FilterAlpha:"
			type="number"
			inputmode="numeric"
			pattern="[0-9]*"
			:value="bluetooth.config.rssiFilterAlpha"
			:update="updateFunctionFactory(mutationTypes.bluetoothSetScanConfig, 'rssiFilterAlpha')"
		/>
		<ElementSetting
			name="malus"
			content="RSSI not seen Malus:"
			type="number"
			inputmode="numeric"
			pattern="[0-9]*"
			:value="bluetooth.config.notSeenForOneScanMalus"
			:update="updateFunctionFactory(mutationTypes.bluetoothSetScanConfig, 'notSeenForOneScanMalus')"
		/>
		<ElementSetting
			name="median"
			content="Median Window width:"
			type="number"
			inputmode="numeric"
			pattern="[0-9]*"
			:value="bluetooth.config.medianWindowWidth"
			:update="updateFunctionFactory(mutationTypes.bluetoothSetScanConfig, 'medianWindowWidth')"
		/>
		<ElementHeadlineSmall content="Nearest Beacon Config" />
		<ElementSetting
			name="hysterese"
			content="Hysterese:"
			type="number"
			inputmode="numeric"
			pattern="[0-9]*"
			:value="nearestBeaconAlgorithm.config.hystereseWidth"
			:update="updateFunctionFactory(mutationTypes.nearestBeaconSetConfig, 'hystereseWidth')"
		/>
		<ElementSetting
			name="blockerbonus"
			content="Blocker Bonus:"
			type="number"
			inputmode="numeric"
			pattern="[0-9]*"
			:value="nearestBeaconAlgorithm.config.blockerBonus"
			:update="updateFunctionFactory(mutationTypes.nearestBeaconSetConfig, 'blockerBonus')"
		/>
		<ElementSetting
			name="triggerthreshold"
			content="Trigger Threshold:"
			type="number"
			inputmode="numeric"
			pattern="[0-9]*"
			:value="nearestBeaconAlgorithm.config.triggerThreshold"
			:update="updateFunctionFactory(mutationTypes.nearestBeaconSetConfig, 'triggerThreshold')"
		/>
		<ElementSetting
			name="blockerthreshold"
			content="Blocker Threshold:"
			type="number"
			inputmode="numeric"
			pattern="[0-9]*"
			:value="nearestBeaconAlgorithm.config.blockerThreshold"
			:update="updateFunctionFactory(mutationTypes.nearestBeaconSetConfig, 'blockerThreshold')"
		/>
		<ElementSetting
			name="extenderthreshold"
			content="Extender Threshold:"
			type="number"
			inputmode="numeric"
			pattern="[0-9]*"
			:value="nearestBeaconAlgorithm.config.extenderThreshold"
			:update="updateFunctionFactory(mutationTypes.nearestBeaconSetConfig, 'extenderThreshold')"
		/>
		<ElementSetting
			name="ticstowin"
			content="Tics To Win:"
			type="number"
			inputmode="numeric"
			pattern="[0-9]*"
			:value="nearestBeaconAlgorithm.config.ticsToWin"
			:update="updateFunctionFactory(mutationTypes.nearestBeaconSetConfig, 'ticsToWin')"
		/>
		<ElementSetting
			name="areaThreshold"
			content="areaThreshold:"
			type="number"
			inputmode="numeric"
			pattern="[0-9]*"
			:value="areaBeaconAlgorithm.config.areaThreshold"
			:update="updateFunctionFactory(mutationTypes.areaBeaconSetConfig, 'areaThreshold')"
		/>
		<ElementHeadlineSmall
			:content="
				nearesBeaconWinner
					? `Nearest Beacon: ${nearesBeaconWinner.major}:${nearesBeaconWinner.minor} ${nearesBeaconWinner.rssi}`
					: ''
			"
		/>

		<ElementHeadlineSmall content="Nearest Beacon Winner List" />
		<ElementList :entries="nearestBeaconWinnerList" />
		<ElementHeadlineSmall content="Detected Beacons" />
		<ElementList :entries="detectedBeaconList" />
	</system>
</template>
<script>
import { mapActions, mapState } from 'vuex';
import UiBase from '../ui/base.vue';
import { mutationTypes } from '../../types';
import { uiComponents } from '../../tools/viewState';
import { paddingLeft } from '../../tools/helpers';

export default {
	extends: UiBase,
	data() {
		return {
			name: uiComponents.systemBeacons,
		};
	},
	computed: {
		...mapState({
			toggleLabel: (state) => (state.bluetooth && state.bluetooth.isActive ? 'stop' : 'start'),
			nearestBeacon: (state) => state.nearestBeaconAlgorithm.winner,
			detectedBeaconList: (state) =>
				Object.values(state.bluetooth.detectedBeacons)
					.filter((beacon) => beacon)
					/* eslint-disable no-nested-ternary */
					.sort((a, b) => (a.rssi < b.rssi ? 1 : a.rssi > b.rssi ? -1 : 0))
					.map((beacon, index) => ({
						title: `${paddingLeft('         ', beacon.type)} ${paddingLeft('00', beacon.major)}-${paddingLeft(
							'00',
							beacon.minor
						)} rssi: ${paddingLeft('    ', beacon.rssi)} `,
						name: `beacon-${index}`,
						active:
							state.nearestBeaconAlgorithm.winner &&
							state.nearestBeaconAlgorithm.winner.major === beacon.major &&
							state.nearestBeaconAlgorithm.winner.minor === beacon.minor,
					})),
			nearestBeaconWinnerList: (state) =>
				state.nearestBeaconAlgorithm.winnerList.map((beacon, index) => ({
					title: `${paddingLeft('         ', beacon.type)} ${paddingLeft('00', beacon.major)}-${paddingLeft(
						'00',
						beacon.minor
					)} rssi: ${paddingLeft('    ', beacon.rssi)} `,
					name: `beacon-${index}`,
					active:
						state.nearestBeaconAlgorithm.winner &&
						state.nearestBeaconAlgorithm.winner.major === beacon.major &&
						state.nearestBeaconAlgorithm.winner.minor === beacon.minor,
				})),
			nearesBeaconWinner: (state) => state.nearestBeaconAlgorithm.winner,
		}),
		...mapState(['viewState', 'bluetooth', 'nearestBeaconAlgorithm', 'areaBeaconAlgorithm']),
	},
	methods: {
		...mapActions(['closeModal']),
		toggle() {
			if (this.bluetooth.isActive) {
				this.$store.dispatch('stopBluetooth');
			} else {
				this.$store.dispatch('startBluetooth');
			}
		},
		updateFunctionFactory(mutationType, path) {
			return (value) => {
				const result = {};
				result[path] = value;
				this.$store.commit(mutationType, result);
			};
		},
		createBeaconEntryString() {
			return;
		},
	},

	created() {
		this.mutationTypes = mutationTypes;
		this.bluetoothSetScanConfig = mutationTypes.bluetoothSetScanConfig;
		this.nearestBeaconSetConfig = mutationTypes.nearestBeaconSetConfig;
		this.areaBeaconSetConfig = mutationTypes.areaBeaconSetConfig;
	},
};
</script>
